@if (ad !== null) {
  <div [class]="ad.validated ? 'bg-[#FEFEFE] ':'bg-[#F7F7F7]'"
    class="relative flex flex-col rounded-[6px] border border-[#F1F1F1] overflow-hidden md:rounded-[15px]">
    <div class="flex flex-row">
      <!-- Image -->
      <a class="relative flex h-[85px] w-[140px] items-center justify-center overflow-hidden md:h-[100px] md:w-[220px] md:cursor-pointer rounded-br-[15px]" routerLink="/entry/{{ad.id}}">
        <kaz-blur-image [src]="ad.images.length > 0 ? (ad.images[ad.titleImageIndex] | imageSource) : getDummyPicture(ad)" [placeholder]="ad.images.length === 0"></kaz-blur-image>
        @if (ad.reserved) {
          <div
            class="absolute flex top-0 left-0 w-full h-full bg-black/70 text-xs text-white font-semibold justify-center items-center md:text-base md:rounded-br-[15px]">
            <span>Reserviert</span>
          </div>
        }
        @if (ad.images.length > 0) {
          <span
          class="absolute right-1 bottom-1 bg-[#183C5B] px-1.5 text-xs text-white font-semibold rounded-[2px] md:text-base md:px-3 md:py-1 md:rounded-[4px] md:rounded-br-[15px]">{{ad.images.length}}</span>
        }
      </a>
      <!-- lables -->
      <a class="relative flex flex-col p-4 w-full md:cursor-pointer md:px-6" routerLink="/entry/{{ad.id}}">
        <div class="flex flex-row gap-2 items-center">
          <span class="text-[#161D26] text-sm font-medium line-clamp-2 md:text-lg" [title]="ad.title">{{ad.title}}</span>
          @if (!ad.validated) {
            <fa-icon class="text-kaz-orange" icon="clock" title="Warte auf Freigabe"></fa-icon>
          }
        </div>
        @if (ad.category.subName !== 'Verschenken' && +ad.price > 0) {
          <span
          class="absolute left-4 bottom-1 text-sm text-[#56BA90] font-medium md:left-6 md:bottom-0 md:text-xl md:font-semibold">€ {{ad.price | currency:'EUR':'':'1.0-0':'de-DE'}} {{ad.priceType === PriceType.VHB ? 'VHB' : '' }}</span>
        }
        <div class="absolute right-4 bottom-1 grid grid-cols-[1fr_auto] gap-x-2 text-xs font-medium text-kaz-blue md:right-6">
          <span>Online:</span>
          <div class="text-right">{{ad.publicationDate[0] | date}}</div>
          <span>Endet:</span>
          <div class="text-right">{{ad.expired | date}}</div>
        </div>
        <div class="absolute bottom-2.5 right-5 h-5 flex flex-row gap-1 text-[#999999] text-xs font-medium items-center ">
          <fa-icon class="hidden" icon="eye" size="sm"></fa-icon>
          <span class="hidden mr-2">600</span>
          <fa-icon class="hidden" icon="heart" size="sm"></fa-icon>
          <span class="hidden">300</span>
        </div>
      </a>
    </div>
    <!-- Action Buttons -->
    <div class="grid grid-cols-3 gap-4 text-xs text-kaz-orange font-medium justify-center items-center py-2 px-4 md:p-5">
      <!-- Reserve -->
      <div (click)="toggleReserved()"
        class="flex w-full justify-center py-1 rounded-full border md:cursor-pointer"
        [class]="ad.reserved ? 'bg-kaz-orange text-white border-kaz-orange' : 'border-kaz-orange'">
        <span>{{ad.reserved ? 'Aktivieren' : 'Reservieren'}}</span>
      </div>
      <!-- Edit -->
      <div class="flex grow justify-center w-full border border-kaz-orange py-1 rounded-full md:cursor-pointer"
        routerLink="/entry/edit/{{ad.id}}">
        <span>Bearbeiten</span>
      </div>
      <!-- Löschen -->
      <div (click)="toggleDelete()"
        class="flex grow justify-center w-full border border-kaz-orange py-1 rounded-full md:cursor-pointer"
        [class]="showDelete? 'bg-[#F0811A] text-white border-kaz-orange' : 'border-[#F0811A]'">
        <span>Löschen</span>
      </div>
    </div>
    <!-- Delete -->
    @if (showDelete) {
      <div
        class="absolute flex flex-col gap-3 w-full h-full bg-black/75 backdrop-blur text-white items-center justify-center">
        <span>Sicher?</span>
        <div class="flex flex-row gap-3 text-xs items-center md:gap-5">
          <div (click)="deleteAd()"
            class="flex grow justify-center w-24 border border-kaz-orange bg-kaz-orange py-1 rounded-full md:cursor-pointer">
            <span>Ja</span>
          </div>
          <div (click)="toggleDelete()"
            class="flex grow justify-center w-24 border border-kaz-orange text-kaz-orange py-1 rounded-full md:cursor-pointer">
            <span>Abbrechen</span>
          </div>
        </div>
      </div>
    }
  </div>
}
